import { render } from "./InstrumentsTab.vue?vue&type=template&id=22e92724"
import script from "./InstrumentsTab.vue?vue&type=script&lang=js"
export * from "./InstrumentsTab.vue?vue&type=script&lang=js"

import exportComponent from "/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__